import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const queryFn = (metaDataId: number) => {
    const url = `api/bo/getLatestProgramDate?metaDataId=${metaDataId}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useQueryLatestDateOfProgram = (metaDataId: number) => {
    return useQuery<number, QueryError, number, [QueryKeys, unknown]>({
        queryKey: ['latestDateOfProgram', metaDataId],
        queryFn: () => queryFn(metaDataId),
        enabled: metaDataId !== undefined,
    });
};
